import dayjs from 'dayjs';

export const oneSecond = 1000;
export const oneMinute = oneSecond * 60;
export const oneHour = oneMinute * 60;
export const oneDay = oneHour * 24;

export const midnightToday = () => new Date().setHours(0, 0, 0, 0);

export const midnightTomorrow = () => midnightToday() + oneDay;

export const floorToMidnight = timestamp => new Date(timestamp).setHours(0, 0, 0, 0);

export const convertToSeconds = timestamp => Math.round(timestamp / 1000);

export const convertToMilliseconds = timestamp => timestamp * 1000;

export const getTimeString = (timestamp) => {
  if (timestamp === midnightToday()) {
    return 'Today';
  }
  if (timestamp === midnightTomorrow()) {
    return 'Tomorrow';
  }
  return dayjs(timestamp).format('ddd M/D');
};

export const ceilToMidnight = time => (
  (new Date(time)).getHours() === 0 ? time : floorToMidnight(time) + oneDay
);



// WEBPACK FOOTER //
// ./src/utils/time.js